import { render, staticRenderFns } from "./PasiBsaPhaseV2.vue?vue&type=template&id=2ffc532e&scoped=true&"
import script from "./PasiBsaPhaseV2.vue?vue&type=script&lang=js&"
export * from "./PasiBsaPhaseV2.vue?vue&type=script&lang=js&"
import style0 from "./PasiBsaPhaseV2.vue?vue&type=style&index=0&id=2ffc532e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffc532e",
  null
  
)

export default component.exports